import * as t from 'io-ts';
import { AccountLinkDynamicType } from './accountLink';

export const AccountLinksListDynamicType = t.array(AccountLinkDynamicType);

export type AccountLinksList = t.TypeOf<typeof AccountLinksListDynamicType>;
